<template>
    <v-layout style="max-height: 55px;">
        <v-footer color="black">
            <v-row justify="center" no-gutters>
                <v-col class="text-center mt-4" cols="12">
                    <router-link to="/"><v-tab>DPSG Stamm Heilig Geist</v-tab></router-link>
                    | <router-link to="/impressum"><v-tab>Impressum</v-tab></router-link>
                    | <router-link to="/datenschutz"><v-tab>Datenschutz</v-tab></router-link>
                </v-col>
            </v-row>
        </v-footer>
    </v-layout>
</template>

<style scoped>
a {
    color: white;
    text-decoration: none;
}
</style>
